import { c as _c } from "react/compiler-runtime";
import { Icon, Popover, PopoverContent, PopoverTrigger } from '~/components/primitives';
import type { ClassValue } from 'class-variance-authority/types';
import { cx } from 'class-variance-authority';

/** @internal */
export namespace ActivityFilterPopover {
  export const Root = Popover;
  export function Content(props) {
    const $ = _c(5);
    const t0 = props.className ?? "min-w-[340px] max-w-[360px]";
    let t1;
    if ($[0] !== t0) {
      t1 = cx("w-auto", t0);
      $[0] = t0;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== props.children || $[3] !== t1) {
      t2 = <PopoverContent align="start" sideOffset={20} className={t1}>{props.children}</PopoverContent>;
      $[2] = props.children;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  export function DesktopButton(props) {
    const $ = _c(29);
    if (props.dense) {
      let t0;
      if ($[0] !== props.className) {
        t0 = cx("outline-hidden flex h-9 min-w-0 select-none items-center gap-2 rounded-full px-3 text-sm font-medium text-primary transition-colors hover:bg-black/5 focus-visible:ring-2 focus-visible:ring-turqoise/20 data-[state=open]:bg-black/5", "max-w-[10rem] xl:max-w-[16rem]", props.className);
        $[0] = props.className;
        $[1] = t0;
      } else {
        t0 = $[1];
      }
      const t1 = props["data-testid"];
      const t2 = `${props.label}: ${props.selected || props.placeholder}`;
      let t3;
      if ($[2] !== props.dense.icon) {
        t3 = <Icon name={props.dense.icon} size="xs" strokeWidth={1.75} className="shrink-0 text-blue-400" />;
        $[2] = props.dense.icon;
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      const t4 = props.selected || props.placeholder;
      let t5;
      if ($[4] !== t4) {
        t5 = <span className="truncate">{t4}</span>;
        $[4] = t4;
        $[5] = t5;
      } else {
        t5 = $[5];
      }
      let t6;
      if ($[6] !== props.label || $[7] !== t0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
        t6 = <PopoverTrigger className={t0} data-testid={t1} title={props.label} aria-label={t2}>{t3}{t5}</PopoverTrigger>;
        $[6] = props.label;
        $[7] = t0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
      } else {
        t6 = $[12];
      }
      return t6;
    }
    const t0 = props.compact ? "h-16 min-w-44 px-6 py-3" : "h-16 min-w-48 px-7 py-4";
    let t1;
    if ($[13] !== props.className || $[14] !== t0) {
      t1 = cx("outline-hidden flex select-none items-center justify-between gap-2 rounded-4xl border border-blue-100 bg-white transition-all hover:border-blue-200 hover:ring-2 hover:ring-blue-400/15 hover:ring-offset-0 focus-visible:ring-2 focus-visible:ring-turqoise/20 focus-visible:ring-offset-0 data-[state=open]:border-turqoise data-[state=open]:ring-2 data-[state=open]:ring-turqoise/20 data-[state=open]:ring-offset-0", t0, props.className);
      $[13] = props.className;
      $[14] = t0;
      $[15] = t1;
    } else {
      t1 = $[15];
    }
    const t2 = props["data-testid"];
    let t3;
    if ($[16] !== props.label) {
      t3 = <span className="w-full overflow-hidden text-ellipsis font-medium text-primary">{props.label}</span>;
      $[16] = props.label;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    let t4;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <span aria-hidden={true} className="sr-only">:{" "}</span>;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    const t5 = props.selected || props.placeholder;
    let t6;
    if ($[19] !== t5) {
      t6 = <span className="w-full overflow-hidden text-ellipsis font-normal text-blue-500">{t5}</span>;
      $[19] = t5;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    let t7;
    if ($[21] !== t3 || $[22] !== t6) {
      t7 = <h3 className="flex w-full min-w-0 flex-col justify-center overflow-hidden text-ellipsis whitespace-nowrap text-left text-sm">{t3}{t4}{t6}</h3>;
      $[21] = t3;
      $[22] = t6;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    let t8;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Icon name="chevron-down" className="text-secondary" />;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    let t9;
    if ($[25] !== t1 || $[26] !== t2 || $[27] !== t7) {
      t9 = <PopoverTrigger className={t1} data-testid={t2}>{t7}{t8}</PopoverTrigger>;
      $[25] = t1;
      $[26] = t2;
      $[27] = t7;
      $[28] = t9;
    } else {
      t9 = $[28];
    }
    return t9;
  }
}